import { useEffect } from 'react';

import SuccessPageAttribution from 'views/PostEnrollment/SuccessPageAttribution';

import { SuccessPage } from 'components/SuccessPage';

export default function Success() {
  useEffect(() => {
    window?.scrollTo(0, 0);
  }, []);

  return (
    <SuccessPageAttribution>
      <SuccessPage />
    </SuccessPageAttribution>
  );
}
